import { type RefObject, useEffect } from 'react';

import { openUntrustedUrl } from '@/utils/external-links';

import { SPRITE_EXTERNAL_LINK_MESSAGE_TYPE } from './sprite-srcdoc';

export function useSpriteExternalLinks(
  iframeRef: RefObject<HTMLIFrameElement | null>
): void {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.source !== iframeRef.current?.contentWindow) return;
      const data = event.data as { type?: unknown; url?: unknown };
      if (data?.type !== SPRITE_EXTERNAL_LINK_MESSAGE_TYPE) return;
      if (typeof data.url !== 'string') return;

      openUntrustedUrl(data.url);
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [iframeRef]);
}
